(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
(function () {
        var WIDGET_EN = JSON.parse(String(__pewniaki_inline_cfg[0]));
        var ramka = document.getElementById('widget-podglad');
        var pole  = document.getElementById('widget-kod');
        var info  = document.querySelector('[data-widget-info]');
        if (!ramka || !pole) { return; }

        // Adres bierzemy z DOMENY, ktora wlasnie oglada czlowiek. Na sztywno
        // wpisany `https://pewniaki.pl` dawal na www4 kod, ktorego nie dalo sie
        // sprawdzic — wklejony gdziekolwiek pokazywalby produkcje, nie to, co
        // widac obok w ramce. Po podmianie domeny wyjdzie z tego to samo.
        var BAZA_PODGLAD = ramka.src.split('?')[0];
        // Adres z mapy tras, nie z reki: na /en/widgets kod osadzenia ma prowadzic
        // na /en/widgets/results/ (widget po angielsku), na /o-widget — na /widgets/results/.
        var BAZA_KOD     = location.origin + '' + __pewniaki_inline_cfg[1] + '';

        function ustawienia() {
            var gry = [].slice.call(document.querySelectorAll('[data-widget-gra]:checked'))
                        .map(function (c) { return c.value; });
            var motyw = document.querySelector('input[name="widget-motyw"]:checked');
            var szer  = parseInt(document.getElementById('widget-szerokosc').value, 10);
            if (!(szer >= 200 && szer <= 600)) { szer = 300; }
            return {
                gry: gry,
                motyw: motyw ? motyw.value : 'jasny',
                szer: szer,
                odswiez: document.getElementById('widget-odswiez').checked ? 300 : 0,
                // Szacunek na start. Prawdziwa wysokosc bierzemy z zawartosci
                // ramki po jej zaladowaniu — patrz `dopasujWysokosc()`.
                // Zgadywana liczba tnie tresc albo zostawia pusty pas; obie
                // wersje widac na obrazku i obie sa niepotrzebne, bo widget
                // stoi na TYM SAMYM hoscie i da sie go po prostu zmierzyc.
                wysokosc: Math.max(gry.length, 1) * 205 + 20
            };
        }

        function dopasujWysokosc() {
            try {
                var d = ramka.contentDocument;
                if (!d || !d.body) { return; }
                // Wysokosc dokumentu obejmuje takze pusta czesc starej ramki.
                // Mierzymy sam widget, aby podglad mogl rowniez sie skurczyc.
                var widget = d.querySelector('.widget');
                var h = widget ? Math.ceil(widget.getBoundingClientRect().height) : Math.ceil(d.documentElement.scrollHeight);
                if (h > 40) {
                    ramka.height = h;
                    if (pole.value.indexOf('height="') > -1) {
                        pole.value = pole.value.replace(/height="\d+"/, 'height="' + h + '"');
                    }
                    if (info) {
                        info.textContent = info.textContent.replace(/\d+ px\.$/, h + ' px.');
                    }
                }
            } catch (e) { /* inny host — zostaje szacunek */ }
        }
        ramka.addEventListener('load', dopasujWysokosc);

        function zapytanie(u) {
            return '?gry=' + encodeURIComponent(u.gry.join(',')) +
                   '&motyw=' + u.motyw + '&szer=' + u.szer + (u.odswiez ? '&odswiez=' + u.odswiez : '');
        }

        function odswiez() {
            var u = ustawienia();
            if (u.gry.length === 0) {
                if (info) { info.textContent = WIDGET_EN ? __pewniaki_inline_cfg[2] : __pewniaki_inline_cfg[3]; }
                return;
            }
            ramka.src = BAZA_PODGLAD + zapytanie(u);
            ramka.width = u.szer;
            ramka.height = u.wysokosc;
            // `textarea.value` to TEKST, nie HTML — encji sie tu NIE wpisuje.
            // Do 13.09.2026 szlo tu `.replace(/&/g, '&amp;')` i czlowiek kopiowal
            // adres z doslownym `&amp;motyw=jasny`. Przegladarka czyta wtedy
            // parametr o nazwie `amp;motyw`, wiec motyw i szerokosc przestawaly
            // dzialac u kazdego, kto ten kod wkleil.
            pole.value = __pewniaki_inline_cfg[4] + BAZA_KOD + zapytanie(u) +
                '" width="' + u.szer + '" height="' + u.wysokosc +
                __pewniaki_inline_cfg[5] + (WIDGET_EN ? __pewniaki_inline_cfg[6] : __pewniaki_inline_cfg[7]) + '"></iframe>' +
                ' <a href="' + location.origin + (WIDGET_EN ? '/en' : '') + '" title="' + (WIDGET_EN ? __pewniaki_inline_cfg[8] : __pewniaki_inline_cfg[9]) + '">' + (WIDGET_EN ? __pewniaki_inline_cfg[10] : __pewniaki_inline_cfg[11]) + '</a>';
            if (info) {
                info.textContent = (WIDGET_EN ? __pewniaki_inline_cfg[12] : __pewniaki_inline_cfg[13]) + u.gry.length +
                    (WIDGET_EN ? (u.gry.length === 1 ? ' game' : ' games') : (u.gry.length === 1 ? ' gra' : (u.gry.length < 5 ? ' gry' : ' gier'))) +
                    ', ' + u.szer + '×' + u.wysokosc + ' px.';
            }
        }

        document.querySelectorAll('[data-widget-gra], input[name="widget-motyw"], #widget-szerokosc, #widget-odswiez')
            .forEach(function (el) {
                el.addEventListener('change', odswiez);
                el.addEventListener('input', odswiez);
            });
        odswiez();
    })();
})();
